/// Cart ///
document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('CartDrawer');
  const pageWrapper = document.getElementById('PageWrapper');
  const pageOverlay = document.getElementById('PageOverlay');
  const cartDrawerContent = document.getElementById('CartDrawerContent');
  const closeCartDrawerButton = document.getElementById('CloseCartDrawer');
  const cartCountElement = document.getElementById('CartCount');
  const cartType = (window.cartType || (document.getElementById('CartDrawer') ? 'drawer' : 'page'));
  let cartReturnFocus = null;
  let previousBodyOverflow = '';
  let pageWasInert = false;
  let quantityUpdatePending = false;

  function focusCartDrawer() {
    (closeCartDrawerButton || cartDrawer).focus({ preventScroll: true });
  }

  // Remove the cart-no-transition class once DOM is ready, so the drawer's transitions
  // are only active AFTER initial paint (prevents flash-of-open-cart on refresh).
  requestAnimationFrame(function () {
    document.documentElement.classList.remove('cart-no-transition');
  });

  function openCartDrawer(skipRefresh, trigger) {
    if (cartType !== 'drawer' || !cartDrawer) return;

    const isDesignMode = window.Shopify && Shopify.designMode;
    const wasOpen = cartDrawer.classList.contains('open');
    if (!wasOpen) {
      // Release the mobile menu's scroll lock before saving the cart's return state.
      document.dispatchEvent(new CustomEvent('cart:before-open'));
      cartReturnFocus = trigger || document.activeElement;
      previousBodyOverflow = document.body.style.overflow;
      pageWasInert = pageWrapper ? pageWrapper.inert : false;
    }

    cartDrawer.inert = false;
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.classList.add('open');
    if (!wasOpen) focusCartDrawer();

    if (isDesignMode) {
      cartDrawer.style.zIndex = '999999';
    }

    if (pageWrapper) {
      pageWrapper.classList.add('cart-open');
      pageWrapper.inert = true;
    }
    if (pageOverlay) {
      pageOverlay.classList.add('active');
    }

    document.body.style.overflow = 'hidden';

    if (!skipRefresh) {
      updateCartDrawer();
    }
  }

  function closeCartDrawer() {
    if (!cartDrawer || !cartDrawer.classList.contains('open')) return;

    const isDesignMode = window.Shopify && Shopify.designMode;

    cartDrawer.classList.remove('open');

    if (isDesignMode) {
      cartDrawer.style.zIndex = '';
    }

    if (pageWrapper) {
      pageWrapper.classList.remove('cart-open');
      pageWrapper.inert = pageWasInert;
    }
    if (pageOverlay) {
      pageOverlay.classList.remove('active');
    }

    document.body.style.overflow = previousBodyOverflow;
    if (cartReturnFocus && cartReturnFocus.isConnected && cartReturnFocus.getClientRects().length && !cartReturnFocus.disabled) {
      cartReturnFocus.focus({ preventScroll: true });
    }
    cartDrawer.inert = true;
    cartDrawer.setAttribute('aria-hidden', 'true');
  }

  document.addEventListener('keydown', function (event) {
    if (!cartDrawer || !cartDrawer.classList.contains('open')) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeCartDrawer();
      return;
    }
    if (event.key !== 'Tab') return;

    const controls = Array.from(cartDrawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex="0"]')).filter(function (element) {
      return element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
    });
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!first) {
      event.preventDefault();
      cartDrawer.focus();
    } else if (event.shiftKey && (document.activeElement === first || !cartDrawer.contains(document.activeElement))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !cartDrawer.contains(document.activeElement))) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('focusin', function (event) {
    if (cartDrawer && cartDrawer.classList.contains('open') && !cartDrawer.contains(event.target)) {
      focusCartDrawer();
    }
  });

  if (pageOverlay) {
    pageOverlay.addEventListener('click', function () {
      closeCartDrawer();
    });
  }

  if (closeCartDrawerButton) {
    closeCartDrawerButton.addEventListener('click', function () {
      closeCartDrawer();
    });
  }

  document.addEventListener('click', function (event) {
    if (
      cartDrawer &&
      cartDrawer.classList.contains('open') &&
      !event.composedPath().includes(cartDrawer) &&
      !event.target.closest('a[href*="/cart"]') &&
      event.target !== pageOverlay
    ) {
      closeCartDrawer();
    }
  });

  function updateCartCount(cartItemCount) {
    if (cartCountElement) {
      cartCountElement.textContent = cartItemCount;
    }
  }

  function attachQuantityHandlers() {
    document.querySelectorAll('.cart-drawer__quantity-wrapper').forEach(function (wrapper) {
      const key = wrapper.dataset.key;
      const inventoryQuantity = parseInt(wrapper.dataset.inventory, 10);
      const trackQuantity = wrapper.dataset.trackQuantity === 'true';
      const allowOversell = wrapper.dataset.allowOversell === 'continue' || wrapper.dataset.allowOversell === 'true';

      const minusButton = wrapper.querySelector('.cart-drawer__quantity-btn-minus');
      const plusButton = wrapper.querySelector('.cart-drawer__quantity-btn-plus');
      const quantityValue = wrapper.querySelector('.cart-drawer__quantity-value');

      if (!key || !quantityValue) return;

      function updateButtonStates() {
        const currentQuantity = parseInt(quantityValue.textContent, 10) || 1;

        if (minusButton) {
          minusButton.classList.remove('disabled');
          minusButton.disabled = quantityUpdatePending;
        }

        if (plusButton) {
          if (quantityUpdatePending) {
            plusButton.disabled = true;
          } else if (trackQuantity && !allowOversell) {
            const isMaxQuantity = currentQuantity >= inventoryQuantity;
            plusButton.classList.toggle('disabled', isMaxQuantity);
            plusButton.disabled = isMaxQuantity;
          } else {
            plusButton.classList.remove('disabled');
            plusButton.disabled = false;
          }
        }
      }

      function updateCartQuantity(quantity) {
        if (quantityUpdatePending) return;
        quantityUpdatePending = true;
        cartDrawerContent.setAttribute('aria-busy', 'true');
        const focusedControl = document.activeElement;
        const wasQuantityFocused = focusedControl === minusButton || focusedControl === plusButton;
        const focusSelector = focusedControl === minusButton ? '.cart-drawer__quantity-btn-minus' : '.cart-drawer__quantity-btn-plus';
        attachQuantityHandlers();

        const cartItem = wrapper.closest('.cart-drawer__item');
        if (quantity === 0) {
          if (cartItem) cartItem.classList.add('fade-out');
        }

        function submitQuantityChange() {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: key,
              quantity: quantity
            })
          })
            .then(function (response) {
              if (!response.ok) {
                throw new Error('Error updating cart');
              }
              return response.json();
            })
            .then(function (cart) {
              updateCartCount(cart.item_count);
              // Shopify renders the accepted quantity, discounts and all totals together.
              return refreshDrawerContent();
            })
            .catch(function (error) {
              console.error('Error updating cart quantity:', error);
              if (cartItem) cartItem.classList.remove('fade-out');
            })
            .finally(function () {
              quantityUpdatePending = false;
              cartDrawerContent.removeAttribute('aria-busy');
              attachQuantityHandlers();
              // Disabling a focused button can move focus to body/dialog; restore only if the
              // customer has not moved to another control while the request was pending.
              if (wasQuantityFocused && cartDrawer.classList.contains('open') &&
                  (document.activeElement === document.body || document.activeElement === cartDrawer || document.activeElement === focusedControl)) {
                const updatedWrapper = Array.from(cartDrawerContent.querySelectorAll('.cart-drawer__quantity-wrapper')).find(function (element) {
                  return element.dataset.key === key;
                });
                const updatedControl = updatedWrapper && updatedWrapper.querySelector(focusSelector);
                if (updatedControl && !updatedControl.disabled) updatedControl.focus({ preventScroll: true });
                else focusCartDrawer();
              }
            });
        }

        if (quantity === 0) setTimeout(submitQuantityChange, 200);
        else submitQuantityChange();
      }

      updateButtonStates();
      if (wrapper.dataset.cartQtyBound === 'true') return;
      wrapper.dataset.cartQtyBound = 'true';

      if (minusButton) {
        minusButton.addEventListener('click', function () {
          const currentQuantity = parseInt(quantityValue.textContent, 10) || 1;
          updateCartQuantity(currentQuantity - 1);
        });
      }

      if (plusButton) {
        plusButton.addEventListener('click', function () {
          const currentQuantity = parseInt(quantityValue.textContent, 10) || 1;
          if (trackQuantity && !allowOversell && currentQuantity >= inventoryQuantity) {
            alert('Maximum quantity for this product is ' + inventoryQuantity + '.');
          } else {
            updateCartQuantity(currentQuantity + 1);
          }
        });
      }

    });
  }

  // Fetches the latest drawer HTML and updates content + cart count. Returns a Promise.
  function refreshDrawerContent() {
    if (!cartDrawerContent) return Promise.resolve();
    return fetch('/cart?view=cart-drawer')
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to fetch cart drawer content');
        return response.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.getElementById('CartDrawerContent');
        const newTitle = doc.querySelector('.cart-drawer__title');
        const currentTitle = document.querySelector('.cart-drawer__title');

        if (newContent) {
          const items = cartDrawerContent.querySelector('.cart-drawer__items');
          const itemsScrollTop = items ? items.scrollTop : 0;
          const focusedControl = document.activeElement;
          const replacingFocusedControl = cartDrawerContent.contains(focusedControl);
          const focusedWrapper = replacingFocusedControl && focusedControl.closest('.cart-drawer__quantity-wrapper');
          const focusedKey = focusedWrapper ? focusedWrapper.dataset.key : null;
          const quantitySelector = focusedControl.matches('.cart-drawer__quantity-btn-minus') ? '.cart-drawer__quantity-btn-minus' :
            focusedControl.matches('.cart-drawer__quantity-btn-plus') ? '.cart-drawer__quantity-btn-plus' : null;
          cartDrawerContent.innerHTML = newContent.innerHTML;
          const updatedItems = cartDrawerContent.querySelector('.cart-drawer__items');
          if (updatedItems) updatedItems.scrollTop = itemsScrollTop;
          attachQuantityHandlers();
          if (replacingFocusedControl && cartDrawer.classList.contains('open') && (!quantityUpdatePending || !focusedControl.disabled)) {
            const updatedWrapper = focusedKey && Array.from(cartDrawerContent.querySelectorAll('.cart-drawer__quantity-wrapper')).find(function (element) {
              return element.dataset.key === focusedKey;
            });
            const updatedControl = updatedWrapper && quantitySelector && updatedWrapper.querySelector(quantitySelector);
            if (updatedControl && !updatedControl.disabled) updatedControl.focus({ preventScroll: true });
            else focusCartDrawer();
          }
        }

        if (newTitle && currentTitle) {
          currentTitle.textContent = newTitle.textContent;
          var match = newTitle.textContent.match(/\((\d+)\)/);
          if (match && cartCountElement) {
            cartCountElement.textContent = match[1];
          }
        }
      });
  }

  function updateCartDrawer() {
    return refreshDrawerContent()
      .catch(function (error) {
        console.error('Error updating cart drawer:', error);
      });
  }

  function bindCartTriggers(root) {
    if (!root) return;

    root.querySelectorAll('a[href*="/cart"], button[data-cart-drawer-toggle], .js-cart-toggle').forEach(function (cartTrigger) {
      if (cartTrigger.dataset.cartLinkBound === 'true') return;
      cartTrigger.dataset.cartLinkBound = 'true';

      cartTrigger.addEventListener('click', function (event) {
        if (cartType === 'drawer') {
          event.preventDefault();
          openCartDrawer(false, cartTrigger);
        }
      });
    });
  }

  const addToCartForm = document.getElementById('AddToCartForm');
  if (addToCartForm && !addToCartForm.dataset.cartFormBound) {
    addToCartForm.dataset.cartFormBound = 'true';

    addToCartForm.addEventListener('submit', function (event) {
      event.preventDefault();
      const idInput = addToCartForm.querySelector('input[name="id"]');
      if (!idInput) return;

      const variantId = idInput.value;
      const cartButton = addToCartForm.querySelector('.product-info__cart-btn');
      const originalButtonText = cartButton ? cartButton.innerHTML : '';

      if (cartButton) {
        cartButton.classList.add('adding');
        cartButton.innerHTML = 'ADDING...';
        cartButton.disabled = true;
      }

      // ERD-style flow: add the item, refresh the drawer content, THEN open the drawer.
      // The drawer never shows in an empty/loading state — it slides in with the new item
      // already inside.
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Error adding to cart');
          }
          return response.json();
        })
        .then(function () {
          // Populate the drawer with the new item BEFORE opening it.
          return refreshDrawerContent();
        })
        .then(function () {
          if (cartType === 'drawer') {
            // Open with skipRefresh=true — content is already current.
            openCartDrawer(true, cartButton);
          } else if (cartType === 'page') {
            window.location.href = '/cart';
          }
        })
        .catch(function (error) {
          console.error('Error adding to cart:', error);
        })
        .finally(function () {
          if (cartButton) {
            cartButton.classList.remove('adding');
            cartButton.innerHTML = originalButtonText;
            cartButton.disabled = false;
          }
        });
    });
  }

  bindCartTriggers(document);
  attachQuantityHandlers();

  document.addEventListener('shopify:section:load', function (event) {
    bindCartTriggers(event.target);
    attachQuantityHandlers();
  });
});


/// Product cards ///
(function () {
  function setActiveImage(images, index) {
    if (!images || !images.length) return 0;
    var safeIndex = ((index % images.length) + images.length) % images.length;
    for (var i = 0; i < images.length; i++) {
      images[i].classList.toggle('is-active', i === safeIndex);
    }
    return safeIndex;
  }

  function initOneCard(card) {
    if (!card || card.dataset.productCardBound === 'true') return;
    card.dataset.productCardBound = 'true';

    var container = card.querySelector('.product-image-container');
    if (!container) return;

    var link = container.querySelector('a.product-list__img-link');
    if (!link) return;

    var images = Array.from(link.querySelectorAll('img.product-card__image'));
    if (!images.length) return;

    var hasMultiple = images.length > 1;
    var index = 0;

    var prevBtn = container.querySelector('.product-card-arrow--prev');
    var nextBtn = container.querySelector('.product-card-arrow--next');

    function isMobile() {
      return window.matchMedia('(max-width: 748px)').matches;
    }

    function clampIndex(i) {
      if (!images.length) return 0;
      return ((i % images.length) + images.length) % images.length;
    }

    function setActiveDesktop(i) {
      index = clampIndex(i);
      images.forEach(function (img, idx) {
        img.classList.toggle('is-active', idx === index);
      });
    }

    function bindDesktop() {
      setActiveDesktop(0);

      if (!container.dataset.hoverBound) {
        container.dataset.hoverBound = 'true';

        container.addEventListener('mouseenter', function () {
          if (isMobile() || !hasMultiple) return;
          setActiveDesktop(1);
        });

        container.addEventListener('mouseleave', function () {
          if (isMobile() || !hasMultiple) return;
          setActiveDesktop(0);
        });
      }

      if (prevBtn && !prevBtn.dataset.bound) {
        prevBtn.dataset.bound = 'true';
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (!hasMultiple) return;
          setActiveDesktop(index - 1);
        });
      }

      if (nextBtn && !nextBtn.dataset.bound) {
        nextBtn.dataset.bound = 'true';
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (!hasMultiple) return;
          setActiveDesktop(index + 1);
        });
      }
    }

    var track = null;
    var startX = 0;
    var startY = 0;
    var dx = 0;
    var dragging = false;
    var decided = false;
    var horizontal = false;
    var width = 1;

    function ensureMobileTrack() {
      if (!hasMultiple) {
        setActiveDesktop(0);
        return null;
      }

      track = link.querySelector('.product-card-track');
      if (!track) {
        track = document.createElement('div');
        track.className = 'product-card-track';

        images.forEach(function (img) {
          track.appendChild(img);
        });
        link.appendChild(track);

        images = Array.from(track.querySelectorAll('img.product-card__image'));
      }

      images.forEach(function (img) {
        img.classList.remove('is-active');
        img.style.position = 'relative';
        img.style.inset = '';
        img.style.opacity = '1';
        img.style.visibility = 'visible';
        img.style.pointerEvents = 'auto';
        img.style.flex = '0 0 100%';
        img.style.width = '100%';
        img.style.height = '100%';
        img.style.objectFit = 'contain';
        img.style.transition = 'none';
      });

      track.style.display = 'flex';
      track.style.height = '100%';
      track.style.willChange = 'transform';
      track.style.transition = 'transform 0.25s ease';
      track.style.transform = 'translateX(0px)';

      index = 0;
      width = container.getBoundingClientRect().width || 1;
      track.style.transform = 'translateX(' + (-index * width) + 'px)';

      return track;
    }

    function setTrackTranslate(px, instant) {
      if (!track) return;
      if (instant) track.style.transition = 'none';
      track.style.transform = 'translateX(' + px + 'px)';
    }

    function snapTo(i) {
      if (!track) return;
      index = clampIndex(i);
      dx = 0;
      width = container.getBoundingClientRect().width || 1;
      track.style.transition = 'transform 0.25s ease';
      track.style.transform = 'translateX(' + (-index * width) + 'px)';
    }

    function bindMobileDrag() {
      if (!hasMultiple) return;

      container.addEventListener(
        'touchstart',
        function (e) {
          if (!isMobile()) return;
          if (!track) ensureMobileTrack();
          if (!track) return;
          if (!e.touches || !e.touches[0]) return;

          width = container.getBoundingClientRect().width || 1;
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;

          dx = 0;
          dragging = true;
          decided = false;
          horizontal = false;

          track.style.transition = 'none';
          track.style.transform = 'translateX(' + (-index * width) + 'px)';
        },
        { passive: true }
      );

      container.addEventListener(
        'touchmove',
        function (e) {
          if (!isMobile()) return;
          if (!dragging || !track) return;
          if (!e.touches || !e.touches[0]) return;

          var x = e.touches[0].clientX;
          var y = e.touches[0].clientY;

          var rawDx = x - startX;
          var rawDy = y - startY;

          if (!decided) {
            if (Math.abs(rawDx) > 8 && Math.abs(rawDx) > Math.abs(rawDy)) {
              horizontal = true;
              decided = true;
            } else if (Math.abs(rawDy) > 10) {
              dragging = false;
              decided = true;
              return;
            }
          }

          if (!horizontal) return;

          e.preventDefault();

          dx = rawDx;

          if (index === 0 && dx > 0) dx *= 0.35;
          if (index === images.length - 1 && dx < 0) dx *= 0.35;

          var base = -index * width;
          setTrackTranslate(base + dx, true);
        },
        { passive: false }
      );

      container.addEventListener(
        'touchend',
        function () {
          if (!isMobile()) return;
          if (!track) return;

          if (!dragging) return;
          dragging = false;

          if (!horizontal) {
            snapTo(index);
            return;
          }

          var threshold = width * 0.2;
          if (dx < -threshold) snapTo(index + 1);
          else if (dx > threshold) snapTo(index - 1);
          else snapTo(index);
        },
        { passive: true }
      );
    }

    function applyMode() {
      images = Array.from(link.querySelectorAll('img.product-card__image'));
      hasMultiple = images.length > 1;

      if (isMobile()) {
        ensureMobileTrack();
      } else {
        images.forEach(function (img) {
          img.style.position = '';
          img.style.inset = '';
          img.style.flex = '';
          img.style.width = '';
          img.style.height = '';
          img.style.objectFit = '';
          img.style.transition = '';
          img.style.opacity = '';
          img.style.visibility = '';
          img.style.pointerEvents = '';
        });

        setActiveDesktop(0);
      }
    }

    bindDesktop();
    bindMobileDrag();
    applyMode();

    if (!card.dataset.productCardResizeBound) {
      card.dataset.productCardResizeBound = 'true';
      window.addEventListener('resize', function () {
        clearTimeout(window.__pcardResizeT);
        window.__pcardResizeT = setTimeout(applyMode, 60);
      });
    }
  }

  function initAll(root) {
    var scope = root || document;
    var cards = scope.querySelectorAll('[data-product-card]');
    cards.forEach(function (card) {
      initOneCard(card);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);

    var grid =
      document.querySelector('#CollectionProductGrid') ||
      document.querySelector('.product-grid') ||
      document.querySelector('.collection-grid') ||
      document.querySelector('.product-list') ||
      document.body;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (!m.addedNodes || !m.addedNodes.length) return;
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-product-card]')) {
            initOneCard(node);
          } else if (node.querySelectorAll) {
            initAll(node);
          }
        });
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();


/// Footer Big Logo Fit ///
(function () {
  function fitFooterBigLogoText(root) {
    var scope = root || document;
    scope.querySelectorAll('.footer__big-logo-text').forEach(function (el) {
      var cropWrap = el.closest('.footer__big-logo-crop');
      var fitWrap = el.closest('.footer__big-logo-fit');
      if (!cropWrap || !fitWrap) return;

      el.style.setProperty('--fit', 1);
      cropWrap.style.removeProperty('--cropH');

      var wrapW = fitWrap.getBoundingClientRect().width;
      var textW = el.scrollWidth;
      if (!wrapW || !textW) return;

      var s = wrapW / textW;
      el.style.setProperty('--fit', s);

      requestAnimationFrame(function () {
        var scaledH = el.getBoundingClientRect().height;
        var cropPercent = parseFloat(getComputedStyle(cropWrap).getPropertyValue('--crop')) || 0;

        var cropPx = scaledH * (cropPercent / 100);
        var finalH = Math.max(0, scaledH - cropPx);

        cropWrap.style.setProperty('--cropH', finalH + 'px');
        el.style.setProperty('--cropShift', cropPx + 'px');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    fitFooterBigLogoText(document);
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        fitFooterBigLogoText(document);
      });
    }
  });

  document.addEventListener('shopify:section:load', function (e) {
    fitFooterBigLogoText(e.target);
  });

  window.addEventListener('resize', function () {
    clearTimeout(window.__fitFooterLogoT);
    window.__fitFooterLogoT = setTimeout(function () {
      fitFooterBigLogoText(document);
    }, 80);
  });
})();

/// Page Loader ///
(function () {
  var loader = document.getElementById('pageloader');
  if (!loader) return;

  var active = false;

  function show(noAnim) {
    if (active) return;
    active = true;

    if (noAnim) loader.classList.add('no-anim');
    loader.classList.add('show');

    if (noAnim) {
      requestAnimationFrame(function () {
        loader.classList.remove('no-anim');
      });
    }
  }

  function hide() {
    loader.classList.remove('show');
    active = false;

    document.documentElement.classList.remove('pageloader-hide-body');
    document.documentElement.classList.remove('pageloader-force-show');
  }

  document.addEventListener('DOMContentLoaded', function () {
    show(true);
  });

  if (document.readyState === 'complete') {
    hide();
  } else {
    window.addEventListener('load', function () {
      setTimeout(hide, 80);
    });
  }

  window.addEventListener('pageshow', function () {
    hide();
  });

  function shouldHandle(a, e) {
    if (!a || e.defaultPrevented) return false;
    if (a.classList && a.classList.contains('js-cart-toggle')) return false;
    if (a.closest && a.closest('.js-cart-toggle')) return false;

    const href = a.getAttribute('href');
    if (!href) return false;

    if (
      href === '#' ||
      href === '' ||
      href.startsWith('javascript:') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:')
    ) {
      return false;
    }

    if (href.indexOf('/cart') !== -1 && document.getElementById('CartDrawer')) return false;

    if (href.startsWith('#')) return false;

    if (
      a.closest('.menu-item') &&
      a.parentElement.querySelector('.submenu, .dropdown, .sub-menu')
    ) {
      return false;
    }

    try {
      const u = new URL(href, location.href);
      if (u.pathname === location.pathname && u.search === location.search) {
        return false;
      }
    } catch (e) {
      return false;
    }

    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a');
      if (!shouldHandle(a, e)) return;

      e.preventDefault();
      show(false);

      setTimeout(function () {
        location.href = a.href;
      }, 60);
    },
    true
  );

  setTimeout(hide, 5000);
})();
